module.exports = __webpack_public_path__ + "assets/images/C-grey-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/C-grey-icon.png
// module id = 1322
// module chunks = 1